// datos step B (Roger oct21 11:36 CST): "put in the part of Revisiones that the client says this
// data is wrong so the advisor knows and he can change it in B.PRO, not us".
// A cita row may carry a `datos_dispute` map written by the WhatsApp responder (shared schema:
// twilio-openai-agent/postventa_datos_dispute.py):
//   { status: 'pendiente' | 'atendido', fields: ['telefono', ...] | ['datos'], values: { telefono: '9932092465' },
//     raw_message, messages: [{ ts, text, channel }], ts, updated_ts, vin, phone, channel, message_sid,
//     attended_ts?, attended_by? }
// Pure helpers shared by the Revisiones queue row, the Revisiones card and the Calendar cita detail.
export const DATOS_DISPUTE_ATTR = 'datos_dispute';
export const DATOS_DISPUTE_PENDING = 'pendiente';
export const DATOS_DISPUTE_ATTENDED = 'atendido';
export const DATOS_DISPUTE_FIELDS = ['telefono', 'nombre', 'modelo', 'vin', 'placas', 'email', 'datos'];
const FIELD_FALLBACK_ES = {
  telefono: 'teléfono', nombre: 'nombre', modelo: 'modelo/año/versión', vin: 'número de serie',
  placas: 'placas', email: 'correo electrónico', datos: 'datos registrados',
};

export const datosDisputeOf = (row) => {
  const flag = row && typeof row === 'object' ? row[DATOS_DISPUTE_ATTR] : null;
  return flag && typeof flag === 'object' && Array.isArray(flag.fields) && flag.fields.length > 0 ? flag : null;
};

export const hasDatosDispute = (row) => datosDisputeOf(row) !== null;
export const hasPendingDatosDispute = (row) => datosDisputeOf(row)?.status === DATOS_DISPUTE_PENDING;

// "993 209 2465" for a 10+ digit phone, the raw value otherwise.
export const displayDisputeValue = (field, value) => {
  const v = String(value == null ? '' : value).trim();
  if (field === 'telefono' && /^\d{10,13}$/.test(v)) {
    const nat = v.slice(-10);
    return `${nat.slice(0, 3)} ${nat.slice(3, 6)} ${nat.slice(6)}`;
  }
  return v;
};

// [{ field, label, value }] in the order the customer named them; unknown field keys are dropped.
export const datosDisputeEntries = (flag, tr) => {
  const t = typeof tr === 'function' ? tr : (_k, f) => f;
  const f = flag && typeof flag === 'object' ? flag : {};
  const values = f.values && typeof f.values === 'object' ? f.values : {};
  return (Array.isArray(f.fields) ? f.fields : [])
    .filter((field) => DATOS_DISPUTE_FIELDS.includes(field))
    .map((field) => ({
      field,
      label: t('calendar.datosDispute.fields.' + field, FIELD_FALLBACK_ES[field]),
      value: values[field] ? displayDisputeValue(field, values[field]) : '',
    }));
};

// "Cliente reporta datos incorrectos: teléfono → 993 209 2465; nombre → Juan Pérez"
export const formatDatosDispute = (flag, tr) => {
  const t = typeof tr === 'function' ? tr : (_k, f) => f;
  const entries = datosDisputeEntries(flag, t);
  if (!entries.length) return '';
  const head = t('calendar.datosDispute.marker', 'Cliente reporta datos incorrectos');
  return `${head}: ${entries.map(({ label, value }) => (value ? `${label} \u2192 ${value}` : label)).join('; ')}`;
};

// The customer's own words (newest message last); '' when nothing was kept.
export const datosDisputeText = (flag) => {
  const f = flag && typeof flag === 'object' ? flag : {};
  const msgs = Array.isArray(f.messages) ? f.messages.filter((m) => m && typeof m.text === 'string' && m.text.trim()) : [];
  if (msgs.length) return msgs.map((m) => m.text.trim()).join('\n');
  return typeof f.raw_message === 'string' ? f.raw_message.trim() : '';
};
